import { useReviewRatingsMetadataQuery } from '../graphql';

export const useGetReviewRatingsMetadataQuery = () => {
    const reviews = useReviewRatingsMetadataQuery();

    return [reviews.data] as const;
};
